module.exports = {
          srcSet: "/_next/static/images/home-teaser3-260-6151f5094e3fb18d6bae1f9c72970913.jpg"+" 260w",
          images:[ {path: "/_next/static/images/home-teaser3-260-6151f5094e3fb18d6bae1f9c72970913.jpg",width: 260,height: 260}],
          src: "/_next/static/images/home-teaser3-260-6151f5094e3fb18d6bae1f9c72970913.jpg",
          toString:function(){return "/_next/static/images/home-teaser3-260-6151f5094e3fb18d6bae1f9c72970913.jpg"},
          
          width: 260,
          height: 260
        }